import { Currencies } from '@orbital/games-frontend-library'
import floorFigure from './floorFigure'

const getBetInfo = (
  obj: any,
  precision: number,
  currency: string,
  title: string,
) => {
  const { bet, mult, win } = obj

  const BET_INFO = []
  const BET = {
    title: 'BET',
    content: bet && floorFigure(bet, precision) + ' ' + currency,
  }
  const PAYOUT = {
    title: 'PAYOUT',
    content: mult === '1' ? 'PUSH' : mult === '2' ? '1 to 1' : '0',
  }
  const WIN = {
    title: 'WIN',
    content:
      win === 0
        ? '0.00 ' + currency
        : floorFigure(win, precision) + ' ' + currency,
  }

  BET_INFO.push(BET)
  title === 'ANTE' && BET_INFO.push(PAYOUT)
  BET_INFO.push(WIN)

  return { BET_INFO }
}

export default getBetInfo
